import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

import CurrencySymbol from 'components/ui/CurrencySymbol';

import { CurrencyContainer } from './CurrencyInput.styles';

const CurrencyInput = forwardRef(
  (
    {
      currency,
      className,
      disabled,
      max,
      min,
      name,
      onChange,
      placeholder,
      step = 0.01,
      dataCy = 'cash-tendered',
      dataTestId = 'cash-tendered',
      value,
      defaultValue,
      isControlled = true,
      inline,
      readOnly = false
    },
    ref
  ) => {
    const handleChange = (event) => onChange && onChange(event);

    const inputProps = isControlled ? { value } : { defaultValue, ref };

    return (
      <CurrencyContainer inline={inline} className={className} data-cy={`${dataCy}-container`}>
        <CurrencySymbol currencyCode={currency} />
        <input
          {...inputProps}
          data-cy={dataCy}
          data-testid={dataTestId}
          disabled={disabled}
          name={name}
          onChange={handleChange}
          placeholder={placeholder}
          type="number"
          inputMode="decimal"
          min={min}
          max={max}
          step={step}
          readOnly={readOnly}
        />
      </CurrencyContainer>
    );
  }
);

CurrencyInput.displayName = 'CurrencyInput';

CurrencyInput.propTypes = {
  className: PropTypes.string,
  currency: PropTypes.oneOf(['GBP', 'USD', 'EUR']),
  disabled: PropTypes.bool,
  min: PropTypes.number,
  max: PropTypes.number,
  // isControlled is to make this component work in its 2 use cases (controlled/uncontrolled)
  isControlled: PropTypes.bool,
  name: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  step: PropTypes.number,
  dataCy: PropTypes.string,
  dataTestId: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  inline: PropTypes.bool,
  readOnly: PropTypes.bool
};

export default CurrencyInput;
